import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7249e170"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "simple-text-item-1-container" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_4 = {
  key: 0,
  class: "value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.name), 1),
    _hoisted_3,
    (!_ctx.linkEnabled)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.value), 1))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: "value link",
          to: _ctx.linkPath
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.value), 1)
          ]),
          _: 1
        }, 8, ["to"]))
  ]))
}